import React from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import moment from 'moment';
import PerfectScrollbar from 'react-perfect-scrollbar';
import {
  Box,
  Card,
  Chip,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from '@material-ui/core';

import useStyles from './styles';

function Results({
  className,
  status,
  loading,
  ...rest
}) {
  const classes = useStyles();

  return (
    <Card
      className={clsx(classes.rootResults, className)}
      {...rest}
    >
      <PerfectScrollbar>
        <Box minWidth={700}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell align="left" className={classes.headerCell}>
                  Supermercado
                </TableCell>
                <TableCell align="center" className={classes.headerCell}>
                  Productos scrapeados
                </TableCell>
                <TableCell align="center" className={classes.headerCell}>
                  Fecha
                </TableCell>
                <TableCell align="center" className={classes.headerCell}>
                  Estado
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {loading ? (
                <TableRow>
                  <TableCell colSpan={4} align="center">
                    Cargando...
                  </TableCell>
                </TableRow>
              ) : (
                <>
                  {status && status.length > 0 ? (
                    status.map((row) => (
                      <TableRow
                        hover
                        key={row.supermarket}
                        className={row.failed ? classes.failedRow : null}
                      >
                        <TableCell align="left">{row.supermarket}</TableCell>
                        <TableCell align="center">
                          {row.productsScraped.toLocaleString()}
                        </TableCell>
                        <TableCell align="center">
                          {row.date ? moment(row.date).format('DD/MM/YYYY') : '-'}
                        </TableCell>
                        <TableCell align="center">
                          <Chip
                            size="small"
                            label={row.failed ? 'No escrapeado' : 'Escrapeado'}
                            color={row.failed ? 'default' : 'primary'}
                            variant={row.failed ? 'outlined' : 'default'}
                          />
                        </TableCell>
                      </TableRow>
                    ))
                  ) : (
                    <TableRow>
                      <TableCell colSpan={4} align="center">
                        No se encontraron supermercados
                      </TableCell>
                    </TableRow>
                  )}
                </>
              )}
            </TableBody>
          </Table>
        </Box>
      </PerfectScrollbar>
    </Card>
  );
}

Results.propTypes = {
  className: PropTypes.string,
  status: PropTypes.arrayOf(PropTypes.shape({
    supermarket: PropTypes.string,
    productsScraped: PropTypes.number,
    date: PropTypes.string,
    failed: PropTypes.bool,
  })),
  loading: PropTypes.bool,
};

Results.defaultProps = {
  status: [],
  loading: false,
};

export default Results;
